import * as React from 'react'
import { _route } from '../../routes/config'

import { CreateChildModal, PopupLoader } from 'components'
import { IAddChildContentProps } from './interfaces'

class Content extends React.PureComponent<IAddChildContentProps> {
  render() {
    const {
      loading,
      onSubmit,
      history,
      onChangeRadio,
      isValidForm
    } = this.props

    return loading ? (
      <PopupLoader active={loading} />
    ) : (
      <>
        <CreateChildModal
          open={true}
          onClose={() => history.push(_route.child.list)}
          onSubmit={onSubmit}
          onChangeGender={onChangeRadio}
          isValidForm={isValidForm}
          loading={loading}
        />
      </>
    )
  }
}

export default Content



// WEBPACK FOOTER //
// ./src/pages/AddChild/content.tsx